import { Alert, TextTooltip } from '@components'
import { getSettingsPageUrl } from '@constants'
import { useBusinessContext } from '@context'
import { PlanManagementPanel } from '@pages/SettingsPage/constants'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { FaExclamationTriangle } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const copyKey = 'settings.billing.lucaUsage.paygMissingPaymentMethod'

export const LucaPaygPaymentWarningIcon: React.FC = () => {
  const { t } = useTranslation()
  const label = t(`${copyKey}.title`)

  return (
    <TextTooltip tooltip={label} placement="bottom">
      <WarningIcon aria-label={label} />
    </TextTooltip>
  )
}

export const LucaPaygMissingPaymentMethodAlert: React.FC = () => {
  const { t } = useTranslation()
  const { slug } = useBusinessContext()

  return (
    <Alert
      type="warning"
      marginBottom={0}
      title={t(`${copyKey}.title`)}
      description={
        <Trans
          i18nKey={`${copyKey}.description`}
          components={[
            <AlertLink
              key="payment-method"
              to={getSettingsPageUrl(slug, {
                page: 'plan-management',
                panel: PlanManagementPanel.PAYMENT_METHOD
              })}
            />,
            <AlertLink
              key="payg"
              to={getSettingsPageUrl(slug, { page: 'luca-usage', panel: 'payg' })}
            />
          ]}
        />
      }
    />
  )
}

const WarningIcon = styled(FaExclamationTriangle)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.colors.warning};
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
`

const AlertLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`
